"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysRemaining = exports.getFormattedDate = exports.getIsFiocExpired = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const getIsFiocExpired = (days) => parseInt(days, 10) >= 0;
exports.getIsFiocExpired = getIsFiocExpired;
const getFormattedDate = (date) => web_ui_framework_1.GregorianDate.fromISOString(date).format('MM/DD/YYYY');
exports.getFormattedDate = getFormattedDate;
const getDaysRemaining = (nextReviewDate) => (0, web_ui_framework_1.getDifferenceInDays)(new Date(nextReviewDate), new Date()).toString();
exports.getDaysRemaining = getDaysRemaining;
//# sourceMappingURL=fioc.helpers.js.map